import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { Template } from "PFTypes";

export const getRoleJobCodeDisplayAs = (templates: Template[]) =>
  templates?.find((template) => template.name === "Role")?.schema.properties.job_code?.title || "ID";

export const useRoleJobCode = (): string => {
  const {
    data: { templates }
  } = useMyAccountInfo();

  return getRoleJobCodeDisplayAs(templates);
};
